import { render, staticRenderFns } from "./UserProcessDetailedModal.vue?vue&type=template&id=20c720b3&scoped=true&"
import script from "./UserProcessDetailedModal.vue?vue&type=script&lang=js&"
export * from "./UserProcessDetailedModal.vue?vue&type=script&lang=js&"
import style0 from "./user-process-modal.css?vue&type=style&index=0&id=20c720b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c720b3",
  null
  
)

export default component.exports